export const THUMB_WIDTH = 12;
export const TICK_PROXIMITY_THRESHOLD = 5;
export const TICK_OFFSET = 3;
export const HALF_THUMB_WIDTH = THUMB_WIDTH / 2;
